var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0122 6L14.4023 7.71622L17.0122 9.43244C18.8418 9.43244 20.3303 10.921 20.3303 12.7505V14.5811L22.0465 16.2973L23.7627 14.5811V12.7505C23.7627 9.0283 20.7344 6 17.0122 6Z",
    fill: "#9EA2E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1729 7.71622C16.1729 7.04529 16.4826 6.41194 17.0122 6C13.29 6 10.2617 9.0283 10.2617 12.7505V14.5811L11.9779 16.2973L13.6942 14.5811V12.7505C13.6942 10.921 15.1826 9.43244 17.0122 9.43244C16.4826 9.02051 16.1729 8.38716 16.1729 7.71622Z",
    fill: "#9EA2E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3743 14.5811H14.6062V28H24.3743C25.3377 28 26.1187 27.2164 26.1187 26.2497V16.3314C26.1187 15.3647 25.3377 14.5811 24.3743 14.5811Z",
    fill: "#FFCE71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3506 26.2497V16.3314C16.3506 15.3647 17.1316 14.5811 18.095 14.5811H9.62568C8.66233 14.5811 7.88135 15.3647 7.88135 16.3314V26.2497C7.88135 27.2164 8.66233 28 9.62568 28H18.095C17.1316 28 16.3506 27.2164 16.3506 26.2497Z",
    fill: "#FFCE71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4346 20.4197C19.4346 19.0178 18.2498 17.8927 16.827 17.9911C15.6079 18.0754 14.6283 19.0765 14.5684 20.2971C14.5159 21.3669 15.1547 22.2942 16.0767 22.6725L15.5821 23.5291C15.3216 23.9802 15.6472 24.5442 16.1682 24.5442H17.8319C18.3528 24.5442 18.6785 23.9802 18.418 23.5291L17.9234 22.6725C18.81 22.3087 19.4346 21.4373 19.4346 20.4197Z",
    fill: "#FC8A3D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    stroke: "#BABDCC",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.b4fbea3d1f72bb9431fe3b1f91e6b684.svg";
export { ForwardRef as ReactComponent };